export const PENDING_SUBSCRIPTION_ACTION = 'PENDING_SUBSCRIPTION_ACTION'
export const SET_UPGRADE_PLAN_INFORMATION = 'SET_UPGRADE_PLAN_INFORMATION'
export const COMPLETED_SUBSCRIPTION_ACTION = 'COMPLETED_SUBSCRIPTION_ACTION'
